module.exports = "images/transport_subway.f6ec36dd0a731d9d0237a5e98fb16fd4.png";